<template>
  <modal
    class="addCardToVehicle"
    name="addCardToVehicle"
    transition="pop-out"
    :width="modalWidth"
    :height="490"
  >
    <div class="desktop-modal-container home_modal_container">
      <div class="left-modal-view">
        <img src="@/assets/img/remis-fleet.png" />
      </div>
      <div class="right-modal-view pt-1">
        <div class="section-wrapper">
          <div class="text-center modal_header">
            {{ $t("text.addCardVehicle.title") }}
          </div>
          <form class="mt-4">
            <div class="mt-1">
              <label>{{ $t("text.addCardVehicle.cardNum") }}</label>
              <div class="form_input">
                <input
                  type="number"
                  class="form-control"
                  v-model="cardNumber"
                />
              </div>
            </div>
            <div class="mt-1">
              <label>{{ $t("text.addCardVehicle.newPin") }}</label>
              <div class="form_input">
                <input
                  type="password"
                  maxlength="4"
                  class="form-control"
                  v-model="pin"
                />
              </div>
            </div>
            <div class="mt-1">
              <label>{{ $t("text.addCardVehicle.confirmPin") }}</label>
              <div class="form_input">
                <input
                  type="password"
                  maxlength="4"
                  class="form-control"
                  v-model="confirmPin"
                />
              </div>
            </div>
            <div class="mt-3">
              <div class="form_input">
                <button
                  class="rem-btn w-100 main mobile-btn-height gold_color"
                  @click="addCard($event)"
                  :disabled="isButtonDisabled ? true : null"
                  :style="[
                    isButtonDisabled
                      ? { cursor: 'not-allowed' }
                      : { cursor: 'pointer' },
                  ]"
                >
                  {{ $t("text.addCardVehicle.addCard") }}
                  <img
                    src="@/assets/img/git_loader.gif"
                    style="display: none"
                    width="25px"
                    class="ml-3 loader"
                  />
                </button>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  </modal>
</template>
<script>
import configObject from "@/config";
import JQuery from "jquery";
let $ = JQuery;

const MODAL_WIDTH = 700;

export default {
  name: "addCardToVehicle",
  props: ["vehicleInfo"],
  data() {
    return {
      modalWidth: MODAL_WIDTH,
      cardNumber: null,
      pin: null,
      confirmPin: null,
      isButtonDisabled: false,
    };
  },
  created() {
    this.modalWidth = 850;
    //   window.innerWidth < MODAL_WIDTH ? MODAL_WIDTH / 2 : MODAL_WIDTH;
  },
  methods: {
    closeAddCardModal() {
      this.$modal.hide("addCardToVehicle");
    },
    generateRandomNumber() {
      return Math.floor(Math.random() * 9);
    },
    formatPin(pin) {
      let randNum1 = this.generateRandomNumber();
      let randNum2 = this.generateRandomNumber();
      let randNum3 = this.generateRandomNumber();

      const two = pin.substring(0, 2);
      const lastTwo = pin.slice(2);
      return `${randNum1}${two}${randNum2}${lastTwo}${randNum3}`;
    },
    addCard($event) {
      $event.preventDefault();

      if (!this.cardNumber) {
        this.$toast.open({
          message: this.$t("text.addCardVehicle.cardError"),
          type: "error",
          duration: 5000,
        });
        return;
      }
      if (!this.pin) {
        this.$toast.open({
          message: this.$t("text.addCardVehicle.pinError"),
          type: "error",
          duration: 5000,
        });
        return;
      }
      if (!this.confirmPin) {
        this.$toast.open({
          message: this.$t("text.addCardVehicle.confirmPinError"),
          type: "error",
          duration: 5000,
        });
        return;
      }
      if (this.pin !== this.confirmPin) {
        this.$toast.open({
          message: this.$t("text.addCardVehicle.pinNoMatch"),
          type: "error",
          duration: 5000,
        });
        return;
      }

      let data = {
        cardNumber: this.cardNumber,
        pin: this.formatPin(this.pin),
        vehicleId: this.vehicleInfo.id,
      };

      this.isButtonDisabled = true;
      $(".loader").show();
      this.axios
        .post(
          `${configObject.apiBaseUrl}/Card/LinkToVehicle`,
          data,
          configObject.authConfig()
        )
        .then(() => {
          $(".loader").hide();
          this.isButtonDisabled = false;
          this.closeAddCardModal();
          this.$toast.open({
            message: this.$t("text.addCardVehicle.cardSuccess"),
            type: "success",
            duration: 10000,
          });
          this.$eventHub.$emit("getVehicles");
        })
        .catch((error) => {
          this.isButtonDisabled = false;
          $(".loader").hide();
          this.$toast.open({
            message: error.response.data.message,
            type: "error",
            duration: 5000,
          });
        });
    },
  },
};
</script>
